<template>
  <div class="row">

    <div class="col-md-12">
      <h4 class="title">{{$t("crops")}}</h4>
    </div>

    <div class="col-md-12 card">
      <div class="card-header">
        <p-button class="btn btn-primary pull-right" @click="handleCreateModal">
          <i class="fa fa-plus"></i> {{ $t('new_crop') }}
        </p-button>
      </div>
      <div class="card-body">

        <div class="row">
          <div class="col-md-6">
            <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input
                class="input-sm"
                :placeholder="$t('search')"
                v-model="searchQuery"
                addon-right-icon="nc-icon nc-zoom-split"
              ></fg-input>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <el-table v-loading="loading" :element-loading-text="$t('loading_data') + '...'" class="table-striped" :data="paginated" border style="width: 100%">
            <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" sortable></el-table-column>
            <el-table-column fixed="right" class-name="td-actions text-center" :label="$t('actions')">
              <template slot-scope="props">

                <p-button type="primary" size="sm" icon @click="handleEditModal(props.$index, props.row)">
                  <i class="fa fa-edit"></i>
                </p-button>

                <p-button type="danger" size="sm" icon @click="handleDelete(props.$index, props.row)">
                  <i class="fa fa-times"></i>
                </p-button>

              </template>
            </el-table-column>
          </el-table>
        </div>

      </div>

      <div class="card-footer">
        <paginate :pagination="pagination" :metadata="metaData" :allData="getCrops"></paginate>
      </div>

    </div>

    <!-- Add Modal -->
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{(!updateState) ? $t('new_crop') : $t('edit_crop')}}</h4>
      <ValidationObserver ref="cropForm">
        <form>

          <ValidationProvider name="name" rules="required|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.name" :placeholder="$t('name')" :label="$t('name')"></fg-input>
          </ValidationProvider>

          <ValidationProvider name="common_name" rules="required|min:3" v-slot="{ errors }">
            <fg-input :error="errors[0]" v-model="form.common_name" :placeholder="$t('common_name')" :label="$t('common_name')"></fg-input>
          </ValidationProvider>

        </form>
      </ValidationObserver>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handleCloseModal">{{ $t('cancel') }}</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button v-if="!updateState" type="primary" link @click="createCrop">{{ $t('save') }}</p-button>
          <p-button v-if="updateState" type="primary" link @click="updateCrop">{{ $t('update') }}</p-button>
        </div>
      </template>
    </modal>

  </div>
</template>
<script>
import Vue from "vue";
import { Table, TableColumn, Select, Option } from "element-ui";
import Modal from "src/components/UIComponents/Modal.vue";
import Paginate from '../../../../UIComponents/Paginate.vue';
import PPagination from "src/components/UIComponents/Pagination.vue";

import Con from "@/util/helpers.js";
import Resource from "@/util/Api/resource.js";
const CropResource = new Resource("crops");

export default {
  components: {
    Modal,
    PPagination,
    Paginate
  },
  data() {
    return {
      modals: {
        classic: false
      },
      pagination: {
        perPage: 10,
        perPageOptions: [10, 20, 30, 60, 500, 1000],
        currentPage:1,
        nextPage:'',
        prevPage:'',
        total:'',
        from:'',
        to:'',
        page:'',
      },
      searchQuery:'',
      loading: false,
      updateState: false,
      tableData: [],
      form: {
        id: '',
        name: '',
        common_name: ''
      },
      tableColumns: [
        {
          prop: "id",
          label: this.$t("id"),
          minWidth: 30
        },
        {
          prop: "name",
          label: this.$t("name"),
          minWidth: 200
        },
        {
          prop: "commonName",
          label: this.$t("common_name"),
        }
      ],
      metaData: {
         meta:'',
         links:''
      },
    }
  },

  methods: {

    handleEditModal(index, row) {
       this.form.id = row.id;
       this.form.name = row.name;
       this.form.common_name = row.commonName;
       this.updateState = true;
       this.modals.classic = true
    },

    handleCloseModal() {
        this.modals.classic = false;
        this.updateState = false;
    },

    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },

    resetForm() {
      this.form.name = "";
      this.form.common_name = "";
      this.$refs.cropForm.reset();
    },

    handleCreateModal() {
      this.resetForm();
      this.updateState = false;
      this.modals.classic = true;
    },

    async getCrops(page_url) {

      this.loading = true;

      if(page_url) {
         page_url = Con.splitStringLinks(page_url);
      }

      await CropResource.list(page_url)
      .then(response => {
          this.loading = false;
          if(this.tableData.length > 0){
            this.tableData = [...response.data.data, ...this.tableData];
          } else {
            this.tableData = response.data.data;
          }
          this.metaData.meta = response.data.meta;
          this.metaData.links = response.data.links;
        }).catch(error => {
          console.log('error', error);
          this.loading = false;
        });
    },

    async createCrop() {
       await CropResource.store(this.form)
        .then(response => {
           this.tableData = [response.data, ...this.tableData];
           this.handleCloseModal();
           this.showAlertMessage(this.$t("crop_created"), "success");
        })
        .catch(error => {
          this.showAlertMessage(error.response.data.message, "error");
          if (error.response.data.errors) {
            this.$refs.cropForm.setErrors(error.response.data.errors);
          }
        });
    },

    async updateCrop() {
      await CropResource.update(this.form)
        .then(response => {
          const crop = this.tableData.findIndex(item => item.id === response.data.id);
          this.tableData.splice(crop, 1, response.data)
          this.handleCloseModal();
          this.showAlertMessage(this.$t('crop_updated'), "success");
        })
        .catch(error => {
          this.showAlertMessage(error.response.data.message, "error");
          if (error.response.data.errors) {
            this.$refs.categoryForm.setErrors(
              error.response.data.errors.message
            );
          }
      });
    },

    handleDelete(index, row) {
       this.$confirm(
        this.$t('confirm_delete') + ' ' + this.$t('crops') + "?",
        this.$t('warning'),
        {
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
          cancelButtonClass: "btn-danger",
          confirmButtonClass: "btn-primary",
          type: "warning"
        }
      ).then(() => {
          let indexToDelete = this.tableData.findIndex(
            tableRow => tableRow.id === row.id
          );
          if (indexToDelete >= 0) {
            this.form = row;
            CropResource.destroy(this.form.id)
            .then(response => {
                this.tableData.splice(indexToDelete, 1);
                this.showAlertMessage(this.$t("crop_deleted"), "success");
            }).catch(error => {});
          }
        })
        .catch(() => {});
    },

  },

  created() {
     this.getCrops();
  },

  computed: {
    queriedData() {
        return Con.filterData(this.tableData, this.searchQuery);
    },

    paginated() {
        return Con.paginateData(this.queriedData, this.pagination);
    },
  },

}
</script>
